// Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase"; 
import './HomeStyles.css';
import Header from '/Users/noshadboksh/FINALYEAR/react-schedule/src/components/auth/Header.jsx'; // Make sure this path is correct
import video1 from '../assests/video1.mp4'
import video2 from '../assests/video2.mp4'
import video3 from '../assests/video3.mp4';
import video4 from '../assests/video4.mp4';
import video5 from '../assests/video5.mp4';
import video6 from '../assests/video6.mp4';
import video7 from '../assests/video7.mp4';
import video8 from '../assests/video8.mp4';
import video9 from '../assests/video9.mp4';
import video10 from '../assests/video10.mp4';
import video11 from '../assests/video11.mp4';
import video12 from '../assests/video12.mp4';
import video13 from '../assests/video13.mp4';
import video14 from '../assests/video14.mp4';
import video15 from '../assests/video15.mp4';
import video16 from '../assests/video16.mp4';
import video17 from '../assests/video17.mp4';
import video18 from '../assests/video18.mp4';
import video19 from '../assests/video19.mp4';
import video20 from '../assests/video20.mp4';
import video21 from '../assests/video21.mp4';
import video23 from '../assests/video23.mp4';
import video24 from '../assests/video24.mp4';
import video25 from '../assests/video25.mp4';
import video26 from '../assests/video26.mp4';
import video27 from '../assests/video27.mp4';
import video28 from '../assests/video28.mp4';
import video30 from '../assests/video30.mp4';

import FocusTimer from './FocusTimer';


const videoSources = [
    { id: 0, src: video1, label: "Sea" },
    { id: 1, src: video2, label: "Waterfall" },
    { id: 2, src: video3, label: "Snow Forest" },
    { id: 3, src: video4, label: "Flowers" },
    { id: 4, src: video12, label: "Island" },
    { id: 5, src: video6, label: "Castle 1" },
    { id: 6, src: video14, label: "Forest" },
    { id: 7, src: video15, label: "Traffic" },
    { id: 8, src: video30, label: "City" },
    { id: 9, src: video13, label: "Ocean" },
    { id: 10, src: video11, label: "Sunrise" },
];

const Home = () => {
    const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
   const handleVideoChange = (event) => {
    setSelectedVideoIndex(Number(event.target.value)); // Make sure to convert to Number if the values are indices
};


    useEffect(() => {
        // Set a timeout to change the current video after a short delay
        // This delay allows the new video to preload
        const timeoutId = setTimeout(() => {
            setCurrentVideoIndex(selectedVideoIndex);
        }, 200); // 200ms for preload, adjust as needed

        return () => clearTimeout(timeoutId);
    }, [selectedVideoIndex]);


    return (
        <div className="home-container">
            {/* Pass the required props to the Header component */}
            <Header
                showBackgroundPicker={true}
                onBackgroundChange={handleVideoChange}
                videoSources={videoSources}
            />
             <FocusTimer />  
            <div className="video-container">
            {videoSources.map((video, index) => (
                <video
                    key={video.id}
                    src={video.src}
                    autoPlay
                    loop
                    muted
                    className={`video ${index === currentVideoIndex ? "video-visible" : "video-hidden"}`}
                />
            ))}
        </div>
            <main>
                <div className="main-content">
                    {/* Main content goes here */}
                </div>
            </main>
        </div>
    );
};

export default Home;
